module.exports = __webpack_public_path__ + "static/media/interactivo3.299f9577.png";